import React, { useState } from "react";
import { Container } from "./styles";
import { useAuth } from "../../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { Modal, Input, Button, Upload } from "antd";
import {
  MdEdit,
  MdLogout,
  MdCameraAlt,
  MdPersonOutline,
} from "react-icons/md";
import userPhoto from "../../../images/user.png";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { ViewInput, InputTel } from "../../../GlobalStyles";

export default function PerfilAtendente() {
  const { user, signOut, editUser } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone_number, setPhone_number] = useState(user?.phone_number || "");
  const [password, setPassword] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const handleSignOut = () => {
    signOut();
    navigate("/login");
  };

  const handleChangePhoto = async ({ file }) => {
    const data = new FormData();
    data.append("file", file, file.name);
    await api
      .put(`/collaborator/${user.id}`, data)
      .then((response) => {
        toast.success("Foto do perfil editada com sucesso");
        editUser({ user: response.data });
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  };

  async function editAtendente() {
    setIsLoadingModal(true);
    const data = new FormData();
    data.append("name", name);
    data.append("email", email.toLowerCase().replace(/ /g, ""));
    if (password) {
      data.append("password", password);
    }
    data.append("phone_number", phone_number);

    if (!name || !email) {
      setIsLoadingModal(false);
      return toast.warn("Preencha os campos obrigatórios");
    }

    await api
      .put(`/collaborator/${user.id}`, data)
      .then((response) => {
        toast.success("Perfil editado com sucesso");
        editUser({ user: response.data });
        setVisibleModal(false);
        setPassword("");
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <h1>Meu Perfil</h1>

      <div className="profile-content">
        {/* Card de Foto */}
        <div className="photo-card">
          <div className="photo-container">
            <img
              src={user.photo ? user?.photo_url : userPhoto}
              alt="Foto de Perfil"
            />
            <Upload
              showUploadList={false}
              customRequest={handleChangePhoto}
              accept="image/*"
            >
              <Button
                type="primary"
                shape="circle"
                size="large"
                icon={<MdCameraAlt size={22} />}
                style={{
                  position: "absolute",
                  bottom: 5,
                  right: 5,
                  backgroundColor: "#008037",
                  border: "3px solid #fff",
                  height: 45,
                  width: 45,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </Upload>
          </div>
          <div style={{ textAlign: "center" }}>
            <h3>{user?.name}</h3>
            <p>Perfil de Atendente</p>
          </div>
        </div>

        {/* Card de Informações */}
        <div className="info-card">
          <div>
            <div className="section-title">
              <MdPersonOutline size={20} />
              Informações Pessoais
            </div>

            <div className="info-grid">
              <div className="info-item">
                <label>Nome Completo</label>
                <span>{user?.name}</span>
              </div>
              <div className="info-item">
                <label>E-mail</label>
                <span>{user?.email}</span>
              </div>
              <div className="info-item">
                <label>Telefone</label>
                <span>{user?.phone_number || "Não informado"}</span>
              </div>
            </div>
          </div>

          <div className="actions">
            <button
              className="edit-btn"
              onClick={() => {
                setName(user?.name);
                setEmail(user?.email);
                setPhone_number(user?.phone_number);
                setVisibleModal(true);
              }}
            >
              <MdEdit size={18} /> Editar Dados
            </button>
            <button className="logout-btn" onClick={handleSignOut}>
              <MdLogout size={18} /> Sair da Conta
            </button>
          </div>
        </div>
      </div>

      <Modal
        title="Editar Meus Dados"
        open={visibleModal}
        cancelText="Cancelar"
        onCancel={() => setVisibleModal(false)}
        onOk={editAtendente}
        confirmLoading={isLoadingModal}
        okText="Salvar Alterações"
      >
        <div style={{ marginTop: 20 }}>
          <ViewInput>
            <p>Nome Completo*</p>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome"
            />
          </ViewInput>
          <ViewInput>
            <p>E-mail*</p>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu e-mail"
            />
          </ViewInput>
          <ViewInput>
            <p>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              value={phone_number}
              placeholder="(00) 00000-0000"
              onChange={(e) =>
                setPhone_number(e.target.value.replace(/[^0-9]/g, ""))
              }
            />
          </ViewInput>
          <ViewInput>
            <p>Nova Senha (deixe em branco para não alterar)</p>
            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="****"
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
